/*
 * "Pesquisar ou perguntar à IA": o campo de
 * busca do cabeçalho muda de texto, e o modal de busca ganha, no topo dos
 * resultados, a linha "Perguntar à IA: <consulta>" — que abre a página de
 * conversas com a pergunta já enviada.
 *
 * O GlobalSearch é do bundle principal; o SearchModal é carregado sob demanda,
 * daí o extend pelo nome do módulo.
 */
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';
import Icon from 'flarum/common/components/Icon';
import { t } from '../../utils/settings';
import { aiUsable } from './state';
import { askAi } from './bot/routes';
export default function installAskAi() {
  override(GlobalSearch, 'initAttrs', function (original, attrs) {
    original(attrs);
    if (aiUsable('search')) attrs.label = t('ai.search.placeholder');
  });
  extend('flarum/common/components/SearchModal', 'activeTabItems', function (items) {
    if (!aiUsable('search') || !app.route || !('canela.ai.conversations' in app.routes)) return;
    const query = String(this.query?.() || '').trim();
    if (query.length < 2) return;
    items.add('canelaAskAi', m("div", {
      className: "SearchModal-section CanelaAskAi"
    }, m("ul", {
      className: "Dropdown-menu CanelaAskAi-menu"
    }, m("li", null, m("button", {
      type: "button",
      className: "Button Button--link CanelaAskAi-button",
      onclick: () => {
        app.modal.close();
        askAi(query);
      }
    }, m(Icon, {
      name: "fas fa-wand-magic-sparkles",
      className: "CanelaAskAi-icon"
    }), m("span", {
      className: "CanelaAskAi-label"
    }, m("span", {
      className: "CanelaAskAi-prefix"
    }, t('ai.search.ask_prefix')), " ", m("span", {
      className: "CanelaAskAi-query"
    }, query)), m("span", {
      className: "CanelaAskAi-badge"
    }, t('ai.search.badge')))))),
    // Acima de tudo, no topo do menu de busca.
    110);
  });
  const placeholder = function () {
    if (!aiUsable('search')) return;
    const input = this.element?.querySelector?.('.SearchModal-input');
    const label = t('ai.search.placeholder');
    if (input && input.placeholder !== label) input.placeholder = label;
  };
  extend('flarum/common/components/SearchModal', 'oncreate', placeholder);
  extend('flarum/common/components/SearchModal', 'onupdate', placeholder);
}
flarum.reg.add('ramon-canela', 'forum/features/ai/search', installAskAi);